import classNames from "classnames";
import { AnchorProps } from "types";
import styles from "./accordion-link.module.scss";

interface Props extends AnchorProps {
  color?: string;
}

export const AccordionLink = ({ children, className, ...props }: Props) => (
  <a className={classNames(styles.link, className)} {...props}>
    {children}
  </a>
);
